import React from 'react';
import {
  withProductAccordion,
  IProductAccordionProps,
} from '@catalogo/service-americanas-product/src/hocs/product-accordion';
import ExpandButton from '@catalogo/ui-americanas-mobile-accordion-box/src/components/expand-button';
import { Container, ContentWrapper, TitleContainer, ArrowIconUI, WrapperTitle, DivUi, List } from './Styled';
import { IQuestionTips } from '../../../types';

export const QuestionTips = ({
  ref,
  htmlElTitle,
  maxHeightCurrent,
  showExpandButton,
  expandContent,
  isVisible,
  toggleVisible,
  dispatchMetrics,
}: IQuestionTips & IProductAccordionProps) => {
  const onClick = () => {
    if (typeof toggleVisible === 'function') {
      toggleVisible();
    }
    dispatchMetrics('event:track', {
      category: 'qna-pdp',
      action: 'dicas-pergunta',
      label: isVisible ? 'retrair' : 'expandir',
    });
  };

  return (
    <Container id="dicas-pergunta">
      <TitleContainer onClick={onClick}>
        <WrapperTitle as={htmlElTitle as never}>
          Dicas pra sua pergunta
          <ArrowIconUI $isVisible={isVisible} />
        </WrapperTitle>
      </TitleContainer>
      <ContentWrapper ref={ref} style={{ maxHeight: maxHeightCurrent }}>
        <DivUi>
          <List>
            <li>Faça perguntas sobre o produto, características, como utilizá-lo, etc;</li>
            <li>Se a sua dúvida for sobre frete, cupons, prazos e pagamento, você pode conferir nossa FAQ;</li>
            <li>Não inclua palavrões, números de telefone, links de outros sites e endereços.</li>
          </List>
        </DivUi>
      </ContentWrapper>
      <ExpandButton showExpandButton={showExpandButton} expandContent={expandContent as () => void} />
    </Container>
  );
};

export default withProductAccordion(QuestionTips);
